export const completedAttemptCount = assessment => {
  const parsed = Number.parseInt(assessment?.completed_attempt_count, 10);
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
};

export const balancedRecommendation = (assessments, blockedAssessmentIds = new Set()) => {
  const rows = Array.isArray(assessments) ? assessments : [];
  return rows.find(assessment =>
    (assessment?.is_recommendation === true || assessment?.is_balanced_recommendation === true) &&
    !blockedAssessmentIds.has(String(assessment.id))
  ) || rows.find(assessment => !blockedAssessmentIds.has(String(assessment.id))) || null;
};

export const balancedRecommendationText = assessment => {
  if (!assessment) return '';
  const count = completedAttemptCount(assessment);
  if (assessment?.recommendation_mode === 'instructional_priority') {
    const reason = String(assessment?.recommendation_reason || assessment?.priority_reason || '').trim();
    return `Recommended next because this area needs instructional attention${reason ? `: ${reason}` : '.'}`;
  }
  return `Recommended next because it has the fewest completed attempts (${count}) for balanced practice.`;
};
